/**
 * Available translation languages
 */
export enum Language {
	GERMAN = "de",
	ENGLISH = "en"
}

/**
 * globally used {@link i18next} variables
 */
export interface I18nGlobals {
	language: string;
}